export default __webpack_public_path__ + "114ceacac6dd5028f2f93d17944052f1.png";